import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react"
import ModalPortal from "../../Assets/ModalPortal/ModalPortal"
import clsx from "clsx"
import Button from "../../Assets/Button/Button"
import { useScrollBlock } from "../../../hooks/useScrollBlock"
import QRScan from "../../QRScan/QRScan"
import QRScan3 from "../../QRScan/QRScan3"
import { useTranslation } from "react-i18next"
import styles from "./QrScanModal.module.scss"
import { CameraDevice } from "html5-qrcode"
import { SELECTED_QR_CAMERA } from "../../../utils/constants"
import { getCookie } from "../../../utils/cookies"
import ManualCodeModal from "../ManualCodeModal/ManualCodeModal"

interface Props {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  afterScanningFunc?: (time?: string, objectID?: string) => void
  callbackError?: (err?: any) => void
  afterNavigate?: (obj: string, projectID: string) => void
  values?: any
}

const QrScanModal = ({ open, setOpen, afterScanningFunc, callbackError, afterNavigate, values }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })
  const [isManualActive, setIsManualActive] = useState<boolean>(false)
  const [isQrActive, setQrActive] = useState<boolean>(false)
  const [isQrLoading, setQrLoading] = useState<boolean>(false)
  const [qrIsError, setqrIsError] = useState<boolean>(false)
  const [nowActiveCamera, setNowActiveCamera] = useState<number>(Number(getCookie(SELECTED_QR_CAMERA) || 1))
  const [isCameraChanging, setCameraChanging] = useState<boolean>(false)
  const changeCameraTimer = useRef<NodeJS.Timer>()

  const { allowScroll } = useScrollBlock()

  useEffect(() => {
    setTimeout(() => {
      setQrActive(true)
    }, 0)
  }, [])

  useEffect(() => {
    if (!isCameraChanging) {
      clearInterval(changeCameraTimer.current)
      return
    }
    changeCameraTimer.current = setTimeout(() => {
      setCameraChanging(false)
    }, 3_000)
  }, [isCameraChanging])

  const checkSetOpen = (newOpenValue: any) => {
    if (isQrLoading) {
      setOpen(newOpenValue)
    }
  }

  return (
    <>
      <ModalPortal
        isOpen={open}
        setIsOpen={checkSetOpen}
        isCloseBtn={isQrLoading}
        header={!isQrLoading ? false : <h2 className={clsx("modal__title")}>{t("qr.scan")}</h2>}
        className={clsx(styles.modal, isCameraChanging && styles["modal--is-btn-back-disabled"])}
      >
        {!qrIsError && (
          <p className={styles.description}>
            <span>
              {t("qr.pointCameraAtQr")}
              <br />
              {t("or")}
              <span className={styles.manual} onClick={() => setIsManualActive(true)}>
                {t("enterManual")}
              </span>
            </span>
          </p>
        )}
        <div className={styles.qrWrap}>
          {isQrActive && (
            <QRScan3
              isQrLoading={isQrLoading}
              setQrLoading={setQrLoading}
              nowActiveCamera={nowActiveCamera}
              qrIsError={qrIsError}
              setQrIsError={setqrIsError}
              afterScanningFunc={afterScanningFunc}
              callbackError={callbackError}
              setOpen={checkSetOpen}
              afterNavigate={afterNavigate}
              setIsManualActive={setIsManualActive}
              setCameraChanging={setCameraChanging}
            />
          )}
        </div>
        <footer className={styles.footer}>
          {!qrIsError && (
            <Button
              txt={t("changeQrCamera")}
              disabled={isCameraChanging}
              onClick={() => {
                setCameraChanging(true)
                setNowActiveCamera((prev) => {
                  return prev + 1
                })
              }}
              className={styles.btnBack}
            />
          )}
          <Button
            txt={t("back")}
            mode={"gray"}
            disabled={isCameraChanging}
            onClick={() => {
              allowScroll(true)
              setQrActive(false)
              checkSetOpen(false)
            }}
            className={styles.btnBack}
          />
        </footer>
      </ModalPortal>
      <ManualCodeModal
        isOpen={isManualActive}
        setIsOpen={setIsManualActive}
        afterScanningFunc={afterScanningFunc}
        afterNavigate={afterNavigate}
        values={values}
      />
    </>
  )
}

export default QrScanModal
